(function ($) {
  videoCategoryDetailFormatterV1 = {
    formatter: $('.video-category-detail-formatter-v1')
  };

  Drupal.behaviors.videoCategoryDetailFormatterV1 = {
    get: function (key) {
      return videoCategoryDetailFormatterV1[key];
    },

    set: function (key, val) {
      videoCategoryDetailFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      $('.caption-bar').css('bottom', '100px');
      $('.item-video-video .videotype').hide();
      $('.breadcrumbs').hide();
      formatter.each(function () {
        var thisFormatter = $(this);

        // if this formatter is not part of a video category row
        if (thisFormatter.parents('.row').length == 0 && $('body').hasClass('device-pc')) { // if (thisFormatter.parents('.row').length == 0) {
          var fixAutoHeightRows = function () {
          // fix for auto-height row from external formatters
            var rows = thisFormatter.find('.item-video-node.active').find('.row');

            rows.each(function () {
              var columns = $(this).find('li');
              // equal heights
              var columnHeight = 0;

              $(window).resize(function () {
                columns.each(function () {
                  $(this).css('height', 'auto');
                  var thisHeight = $(this).outerHeight(true);

                  if (thisHeight > columnHeight) {
                    columnHeight = thisHeight;
                    $(window).resize();

                    return;
                  }
                }).css('height', columnHeight + 'px');
              }).resize();
            });
          };
          // grab all videos, add item number, wrap, and move container
          var videos = thisFormatter.find('.item-video-video')
            .each(function (i) {
              $(this).attr('item', i);
            })
            .appendTo(thisFormatter.find('.active-video'));

          // add .outer-wrap
          thisFormatter.wrapInner('<div class="outer-wrap" />');

          // ensure heading object exists
          var heading = thisFormatter.find('.video-category-title');

          if (heading.length == 0) {
            thisFormatter.find('.outer-wrap').last().prepend('<div class="video-category-title"></div>');
            heading = thisFormatter.find('.video-category-title');
          }

          // grab all node, add item number, wrap, and move container
          var nodes = thisFormatter.find('.item-video-node')
            .each(function (i) {
              $(this).attr('item', i);
            })
            .wrapAll('<div class="item-video-nodes" />')
            .parent()
            .appendTo(thisFormatter);
          // activate first video/node pair
          var firstItem = thisFormatter.find('[item="0"]');

          firstItem.addClass('active');

          fixAutoHeightRows();

          // update heading
          var firstHeading = firstItem.find('.item-video-title').html();
          var firstHeading = $('.outer-wrap ul.breadcrumbs li').html();

          heading.html(firstHeading);
          // heading.html(firstHeading);

          // cleanup empty containers
          thisFormatter.find('.item-video').each(function () {
            $(this).remove();
          });

          // build carousel from videos
          var flexsliderID = '#' + thisFormatter.find('.flexslider').attr('id');
          var flexslider = $(flexsliderID);
          var slides = flexslider.find('.slides');
          var visibleItems = 3;

          // make a copy to build out the carousel
          videos.each(function (i) {
            $(this).clone().appendTo(slides);
          });

          // wrap visibleItems into each slide
          var items = slides.find('.item-video-video');

          for (var i = 0; i < items.length; i += visibleItems) {
            items.slice(i, i + visibleItems).wrapAll('<li></li>');
          }

          var flexsliderDir = flexslider.data('direction');
          var rtl = flexsliderDir && flexsliderDir == 'rtl' ? true : false;

          // init flexslider
          flexslider.flexslider({
            animation: 'slide',
            animationLoop: true,
            direction: 'vertical',
            slideshow: false,
            rtl: rtl
          }).addClass('flexslider-active');

          // hover state
          var thumb = thisFormatter.find('.item-video-thumb');

          thumb.wrapInner('<div class="clip-thumb" />').hover(function () {
            $(this).addClass('hover');
          }, function () {
            $(this).removeClass('hover');
          });
          var poster_src = $('.item-video-thumb .clip-thumb img').attr('src');
          // YouTube autoplay suffix
          var autoplayString = '&autoplay=1';

          // backup original video src
          thisFormatter.find('.active-video .item-video-html iframe').each(function () {
            var src = $(this).attr('src');

            $(this).attr('original-src', src);
          }).wrap('<div class="flex-video" />');

          // remove extra video embeds
          thisFormatter.find('.flexslider-nav').find('.item-video-html').each(function () {
            $(this).remove();
          });
          thisFormatter.find('.active-video .item-video-html video').attr('poster', poster_src);
          // active state
          thisFormatter.find('.flexslider-nav .item-video-thumb').once('item-video-thumb').on('click', function() {
          // update heading
          // var newHeading = $(this).siblings('.item-video-title').html();
          // heading.html(newHeading);

            // active thumb
            thisFormatter.find('.flexslider-nav .item-video-video').removeClass('active');
            $(this).parents('.item-video-video').addClass('active');

            // stop previous video
            var activeVideo = thisFormatter.find('.active-video');
            var prevItem = activeVideo.find('.item-video-video:visible').attr('item');
		  var videoType_pre = activeVideo.find('.item-video-video[item=' + prevItem + '] .videotype').html();

            if (videoType_pre == 'youtube') {
		    var prevIframe = activeVideo.find('.item-video-video[item=' + prevItem + '] iframe');
		    var prevIframeSrc = prevIframe.attr('original-src');

              prevIframe.attr('src', '');
              prevIframe.attr('src', prevIframeSrc);
            } else {
              var prevIframe = activeVideo.find('.item-video-video[item=' + prevItem + '] video');
              var prevIframeSrc = prevIframe.attr('src');

              prevIframe.attr('src', '');
              prevIframe.attr('src', prevIframeSrc);
              prevIframe.removeAttr('autoplay');
		  }

            // autoplay next video
            var item = $(this).parents('.item-video-video').attr('item');
            var videoType_next = activeVideo.find('.item-video-video[item=' + item + '] .videotype').html();

            if (videoType_next == 'youtube') {
		    var iframe = activeVideo.find('.item-video-video[item=' + item + '] iframe');
              var iframeSrc = iframe.attr('original-src');
              var autoplaySrc = iframeSrc + autoplayString;

              iframe.attr('src', autoplaySrc);
            } else {
              var iframe = activeVideo.find('.item-video-video[item=' + item + '] video');
              var iframeSrc = iframe.attr('src');

              iframe.attr('src', iframeSrc);
              iframe.attr('autoplay', 'autoplay');
            }

            // toggle visibility
            activeVideo.find('.item-video-video').removeClass('active');
            activeVideo.find('.item-video-video[item=' + item + ']').addClass('active');

            thisFormatter.find('.item-video-node').removeClass('active');
            thisFormatter.find('.item-video-node[item=' + item + ']').addClass('active');

            fixAutoHeightRows();
          });

          // detect page hash index number, show relevant video
          var index = 0;
          var hash = window.location.hash;

          if (hash) {
            index = /\d+/.exec(hash)[0];
            index = parseInt(index) || 0;
            if (index > 0) {
              slides.find('.item-video-video[item=' + index + '] .item-video-thumb').trigger('click');
            }
          }
        } // end if
      });
    }
  };
})(jQuery);
